import React from 'react';
import PdfViewer from '../components/PdfViewer';
import './DashboardView.css';
import './Jenny.css';
import KidBalance from '../components/Economy/KidBalance';

function Jenny(props) {
    var timestamp = new Date().getTime();
    var url = `https://kvalstadfamlylifestorage.blob.core.windows.net/jennystorage/ukeplan.pdf?t=${timestamp}`;
    return (
        <div className="jennygrid-container">
            <div className="jennygrid-item jennygrid-item1" id="ukeplanId">
                <PdfViewer parentId="ukeplanId" file={url} />
            </div>
            <div className="jennygrid-item jennygrid-item2">
                <KidBalance kidName='Jenny' />
            </div>
        </div>
    );
}

export default Jenny;